import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_KEY = 'board/:boardId/reporting/stages';

export function useOpportunityReportingStagesQuery({
	boardId,
	filterRequest,
	enabled,
}: {
	boardId: string;
	filterRequest: Api.IOpportunityReportingFilterRequest;
	enabled: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load opportunity stages',
		},
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IOpportunityReportingStagesResponse>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `board/${boardId}/reporting/stages` }),
				'POST',
				filterRequest
			),
		queryKey: [BASE_KEY, boardId, filterRequest],
		refetchOnWindowFocus: false,
	});
}
